import Settings from '../settings';

export default class {
  constructor(dataService, coachGateway) {
    this.initialDataInteractor = dataService;
    this.coachGateway = coachGateway;
  }

  getReportUrlFor(instance) {
    return `${Settings.serviceUrl}/api/v1/questionnaire/report/${instance.identifier}/${encodeURIComponent(this.initialDataInteractor.secretKey)}`;
  }
}